import { render, staticRenderFns } from "./TfaSection.vue?vue&type=template&id=de5837d2&scoped=true&"
import script from "./TfaSection.vue?vue&type=script&lang=js&"
export * from "./TfaSection.vue?vue&type=script&lang=js&"
import style0 from "./TfaSection.vue?vue&type=style&index=0&id=de5837d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5837d2",
  null
  
)

/* custom blocks */
import block0 from "./TfaSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports